import { SetStateAction } from "react";
import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";
import { sendData } from "../../../services/sendData";
import { toPrice } from "../../../utils/toPrice";
import convertDate from "../../../utils/convertDate";
import { getItemType } from "../../../utils/getItemType";
import { getPrefix } from "../../../utils/getPrefix";
import { openDocTransfer } from "../functions/openDocTransfer";

const inputsValues = [
  { code: "branch", type: "select", label: "c.SUC", options: [] },
  {
    code: "doc",
    type: "select",
    label: "p.document",
    options: [{ code: "PRE", label: "PREP" }, { code: "FAC" }, { code: "SEV" }],
  },
  { code: "code", type: "integer", label: "p.code" },
  { code: "customer", type: "text", label: "p.customer" },
];

const findDocsForReturn = async ({
  windowValues,
  setWindowValues,
  logoutAction,
}: stdObject) => {
  setWindowValues({ ...windowValues, loading: true });
  const payloadDocsForReturn = {
    type: windowValues.doc,
    serie: windowValues.branch,
    code: windowValues.code,
    customer: windowValues.customer,
  };
  console.log("payloadDocsForReturn", payloadDocsForReturn);
  const responseReturnDocs = await sendData({
    endPoint: "callDocsForReturn",
    payload: payloadDocsForReturn,
    logoutAction,
  });
  console.log("responseReturnDocs", responseReturnDocs);
  setWindowValues({
    ...windowValues,
    table:
      responseReturnDocs.success && responseReturnDocs.status
        ? responseReturnDocs.docs
        : [],
    loading: false,
  });
};

const createReturn = async ({
  e,
  type,
  serie,
  user,
  userAccess,
  openModal,
  closeMsg,
  logoutAction,
}: stdObject) => {
  let responsePrevData: stdObject = {};
  if (e) {
    responsePrevData = await sendData({
      endPoint: "getPrevDataForReturn",
      payload: {
        type,
        serie,
        code: e[`COD${type}`],
      },
      logoutAction,
    });
    const itemCodes = responsePrevData.itemCodes.map(
      (e: stdObject) => e.COLUMN_NAME,
    );
    console.log("responsePrevData", responsePrevData);

    const itemType = getItemType(type);
    responsePrevData.items = responsePrevData.items.map((e: stdObject) => {
      let tempItem: stdObject = {};
      itemCodes.forEach((v: string) => {
        const pref = getPrefix(v);
        switch (pref) {
          case "SER":
            tempItem[v] = user.CODSUC;
            break;
          case "COD":
          case "PEN":
          case "PEN2":
          case "LIN1":
          case "MOD":
            tempItem[v] = 0;
            break;
          case "POR":
            tempItem[v] = "";
            break;
          default:
            if (`${getPrefix(v)}${itemType}` in e) {
              tempItem[v] = e[getPrefix(v) + itemType];
            }
            break;
        }
      });
      return tempItem;
    });

    closeMsg();
    closeMsg(2);

    openDocTransfer({
      level: 2,
      docValues: { type, itemType, serie, code: e[`COD${type}`] },
      openModal,
      closeMsg,
      items: responsePrevData.items,
      country: user.CODPAI,
      userAccess,
      logoutAction,
    });
  }
};

export const returnModal = ({
  t,
  user,
  userAccess,
  openModal,
  sucsList,
  windowValues,
  setMsg2,
  setModalData2,
  setWindowValues,
  closeMsg,
  logoutAction,
}: stdObject) => {
  const validate = () =>
    "customer" in windowValues &&
    "code" in windowValues &&
    (windowValues.customer?.trim() !== "" || windowValues.code?.trim() !== "");

  return {
    title: t("p.newREG"),
    blocked: true,
    inputs: inputsValues.map((e: stdObject) => {
      return {
        label: t(e.label),
        value: windowValues[e.code] ?? "",
        type: e.type,
        active: !windowValues.loading,
        options:
          e.code === "branch"
            ? sucsList.map((v: stdObject) => {
                return { label: v.NOMSUC, value: v.CODSUC };
              })
            : e.options &&
              e.options.map((v: stdObject) => {
                return {
                  label: v.label ? t(`c.${v.label}`) : t(`c.${v.code}`),
                  value: v.code,
                };
              }),
        onChange: (o: { target: { value: SetStateAction<string> } }) =>
          setWindowValues({ ...windowValues, [e.code]: o.target.value }),
        onKeyDown: (e: stdObject) => {
          if (e.key === "Enter" && validate())
            findDocsForReturn({ windowValues, setWindowValues, logoutAction });
        },
      };
    }),
    table: windowValues.table
      ? windowValues.table.map((e: stdObject, index: number) => {
          return {
            data: [
              e[`COD${windowValues.doc}`],
              convertDate({ info: e[`FEC${windowValues.doc}`], t }),
              `(${e[`CLI${windowValues.doc}`]}) ${e[`NOM${windowValues.doc}`]}`,
              toPrice(e[`TOT${windowValues.doc}`]),
            ],
            onClick: () => {
              setMsg2("custom2");
              setModalData2({
                title: t("p.askCreateReturn"),
                label:
                  t(
                    `c.${windowValues.doc === "PRE" ? "PREP" : windowValues.doc}`,
                  ) + ` ${windowValues.branch}-${e[`COD${windowValues.doc}`]}`,
                buttons: [
                  {
                    label: t("p.accept"),
                    onClick: () =>
                      createReturn({
                        e,
                        type: windowValues.doc,
                        serie: windowValues.branch,
                        user,
                        userAccess,
                        openModal,
                        closeMsg,
                        logoutAction,
                      }),
                    color: colors.green,
                  },
                  {
                    label: t("p.cancel"),
                    onClick: () => closeMsg(2),
                    color: colors.darkGrey,
                  },
                ],
              });
            },
            style: {
              backgroundColor:
                index % 2 === 0 ? colors.white : colors.lightGrey,
            },
          };
        })
      : [],
    buttons: [
      {
        label: t("p.search"),
        onClick: validate()
          ? () =>
              findDocsForReturn({ windowValues, setWindowValues, logoutAction })
          : null,
        color: validate() ? colors.green : colors.darkGrey,
      },
      {
        label: t("p.emptyDocument"),
        onClick: () =>
          createReturn({
            e: false,
            type: windowValues.doc,
            serie: windowValues.branch,
            user,
            userAccess,
            openModal,
            closeMsg,
            logoutAction,
          }),
        color: colors.blue,
      },
      {
        label: t("p.cancel"),
        onClick: closeMsg,
        color: colors.darkGrey,
      },
    ],
  };
};
